<template> 
      <v-form ref="form" v-model="isValid">
        <v-card class="custom-card">
          <v-card-text class="pa-3">
            <!-- common printer selection form -->
            <printer-form
              title="Kitchen Printer"
              title-caption="Used for printing Kitchen Order Tickets (KOT) and other KOT-related tasks."
              :value="req.kot_settings"
              @input="updateValue"
            />

            <!-- if printer enabled use has to select one of the action -->
            <!-- <v-layout wrap align-center class>
              <v-flex xs12 class="check-label">
                <v-checkbox
                  v-model="req.kot_settings.use_kot_config"
                  color="primary"
                  label="Use For KOT Device Config"
                  hint="Enable this option to use only if KOT device configuration is enabled in KOT Device Settings"
                  persistent-hint
                  class="px-2"
                  :disabled="req.kot_settings.printer_type == '0'"
                ></v-checkbox>

                <v-checkbox
                  v-model="req.kot_settings.chef_print"
                  color="primary"
                  label="Use For Chef Print"
                  hint="Enable this option to print Kot as single print"
                  persistent-hint
                  class="px-2"
                  :disabled="req.kot_settings.printer_type == '0'"
                ></v-checkbox>
              </v-flex>
            </v-layout> -->
          </v-card-text>
          <v-divider></v-divider>
          <!-- save button -->
          <v-card-actions class="py-3 justify-center">
            <v-btn
              color="primary"
              class="white--text"
              @click="save"
              :disabled="!validate()"
            >Save</v-btn>
          </v-card-actions>
        </v-card>
  </v-form>
</template>

<script>
import PrinterFormMixin from "../modules/printManager/PrinterFormMixin";
import { PRINTER_TYPES } from "@/modules/printManager/Utils";
import PrinterForm from "./PrinterForm.vue";
export default {
  components: {
    PrinterForm
  },
  mixins: [PrinterFormMixin],
  methods: {
    // check form is valid
    validate() {
      if (!this.$refs.form) {
        return false;
      }
      const valid = this.$refs.form.validate();
      return valid && this.req.kot_settings.validPrinter;
    },

    // save : record the settings in server
    save() {
      if (!this.validate()) {
        return;
      }

      this.req.kot_settings.use_kot_config = true;

      // once form is valid check any one option of chef or kot device config is enabled.
      // if (
      //   this.req.kot_settings.printer_type != PRINTER_TYPES.NO_PRINT.value &&
      //   !this.req.kot_settings.chef_print &&
      //   !this.req.kot_settings.use_kot_config
      // ) {
      //   this.$store.commit("showSnackbar", {
      //     message:
      //       "Select at least one option: Use KOT Device Config or Chef Print.",
      //     color: "error",
      //   });
      //   return;
      // }

      this.submit();
    },
    updateValue(v) {
      this.req.kot_settings = v;
    }
  }
};
</script>

<style>
</style>
